import store from "@/store";
import { translation } from "@/plugins/i18n";
import {
  computedCallingPlans,
  computedPbxAddonPlans,
  computedPbxFeaturePlans,
  computedPbxPlans,
} from '@/common/service/computers/plans/pbx';
import BillingMessageBox from '@/components/common/message-box';
import { getPbxContactSalesLink } from '@/utils/i18n-shortcuts';
import { planTypes } from '@/common/constants';
import { isProductExcludedInShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';
import { isSoftProPlusBundle } from '@/views/config/soft-bundle/helper';

const checkPbxPlansLicense4SoftBundle = (getSelectedPlans = []) => {
  const pbxPlans = computedPbxPlans(getSelectedPlans);
  return isSoftProPlusBundle() && pbxPlans?.length;
}

export const preCheckForPbx = async () => {
  const { getSelectedPlans = [], getUserCurrentSubscriptions = [] } = store.getters;
  const { is, type } = window.$context

  if (type !== planTypes.ZOOM_PHONE || isProductExcludedInShoppingCart(store.getters.getSelectedPlans)) {
    const needCheckPbxLicense4SimilarProPlusBundle = checkPbxPlansLicense4SoftBundle(getSelectedPlans);
    if (!needCheckPbxLicense4SimilarProPlusBundle) return // Only check for PBX plans
  }

  // Check if the total number of calling plans and ZPI plans is more than 99
  const pbxCallingPlans = computedCallingPlans(getUserCurrentSubscriptions);
  const pbxAddonPlans = computedPbxAddonPlans(getSelectedPlans);
  const pbxCallingPlansCount = pbxCallingPlans.reduce((total, x) => total + (x.cartInfo.selected_number ?? 0), 0)
  const pbxAddonPlansCount = pbxAddonPlans.reduce((total, x) => total + (x.cartInfo.selected_number ?? 0), 0)

  if (pbxCallingPlansCount + pbxAddonPlansCount > 99) {
    if (is.configPage) {
      BillingMessageBox.alert(translation('billing.pbx.more_than_numbers', [99, getPbxContactSalesLink()]), translation('billing.buyItNow.cant_continue'), { dangerouslyUseHTMLString: true });
    }
    return Promise.reject({
      message: translation('billing.pbx.more_than_numbers', [99, getPbxContactSalesLink()]),
      duration: 5000
    })
  }

  const pbxZPAPlanCount = computedPbxFeaturePlans(getSelectedPlans).find(x => x.category === 'ZPA')?.cartInfo?.selected_number ?? 0;
  if (pbxZPAPlanCount > pbxCallingPlansCount) {
    if (is.configPage) {
      BillingMessageBox.alert(translation('billing.pbx.add_on_cant_exceed_pbx_sum'), translation('billing.buyItNow.cant_continue'));
    }
    return Promise.reject({
      message: translation('billing.pbx.add_on_cant_exceed_pbx_sum'),
      duration: 5000,
    })
  }
  return Promise.resolve()
}
